export function SectionDivider({ label }: { label: string }) {
    return (
        <div className="flex items-center gap-3 my-2">
            <span
                style={{ fontFamily: 'Manrope' }}
                className="text-xs font-semibold uppercase tracking-widest text-brandPrimary-500 whitespace-nowrap"
            >
                {label}
            </span>
            <div className="flex-1 border-t border-neutral-200" />
        </div>
    );
}